import React from 'react';
import PropTypes from 'prop-types';
import Autosuggest from 'react-autosuggest';
import { Field } from 'redux-form';
import { t } from '../../../../modules/infra/i18n';

const BrandField = ({
  getSuggestionValue,
  renderSuggestion,
  onChange,
  onBlur,
  onSuggestionsFetchRequested,
  onSuggestionsClearRequested,
  value,
  suggestedBrands,
  meta,
  brandIdField,
  input,
}) => {
  const brandsInputProps = {
    name: input.name,
    value,
    onChange,
    onBlur,
    className: 'c-input',
    placeholder: '',
  };

  return (
    <div className="u-position-relative">
      <div className="c-label-new c-brand-autosuggest">{t('admin:users.add.brand_field_label')}</div>
      <Autosuggest
        suggestions={suggestedBrands}
        inputProps={brandsInputProps}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        onSuggestionsFetchRequested={onSuggestionsFetchRequested}
        onSuggestionsClearRequested={onSuggestionsClearRequested}
      />
      <div className="c-input-error-message" display-if={meta.touched && meta.error}>
        {meta.error}
      </div>
      <Field name={brandIdField} id={brandIdField} component="input" type="hidden" />
    </div>
  );
};

BrandField.propTypes = {
  getSuggestionValue: PropTypes.func.isRequired,
  renderSuggestion: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  onSuggestionsFetchRequested: PropTypes.func.isRequired,
  onSuggestionsClearRequested: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  suggestedBrands: PropTypes.array.isRequired, // eslint-disable-line
  meta: PropTypes.object.isRequired, // eslint-disable-line
  brandIdField: PropTypes.string,
  input: PropTypes.object.isRequired,
};

BrandField.defaultProps = {
  brandIdField: 'brandId',
};

export default BrandField;
